import React, { Fragment, useState, useEffect, useCallback } from 'react';
import {
    Row,
    Col,
    Card,
    CardBody,
    ListGroup,
    ListGroupItem,
    Container,
    Button,
    Modal,
    Label,
    ModalHeader,
    ModalBody, FormGroup, Input
} from 'reactstrap';

import api from '../../../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/Auth/AuthContext';

export default function LogsList(props) {
    const { role, toggleModalCallLogs } = props;

    const [logs, setLogs] = useState([]);
    const { currentGroup, toggleLoading } = useAuth();

    const [currentLog, setCurrentLog] = useState(   );

    const [modal, setModal] = useState(false);
    const toggleModal = useCallback(() => {
        setModal(!modal);
    }, [setModal, modal]);

    const [modalEdit, setModalEdit] = useState(false);
    const toggleModalEdit = useCallback(() => {
        setModalEdit(!modalEdit);
    }, [setModalEdit, modalEdit]);
    const [editNotes, setEditNotes] = useState();

    const [lastId, setLastId] = useState(null);

    useEffect(() => {
        api.post(`/ro.team.listGiverLogGift/${currentGroup.id}`)
            .then((response) => {
                setLogs(response.data.items);
                setLastId(response.data.lastId);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    }, [role, currentGroup, setLogs, setLastId]);

    const loadMore = useCallback(() => {
        api.post(`/ro.team.listGiverLogGift/${currentGroup.id}`, {lastId})
            .then((response) => {
                setLogs([...logs, ...response.data.items]);
                setLastId(response.data.lastId);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    }, [currentGroup, lastId, logs, setLogs, setLastId]);

    const convertDate = useCallback((date) => {
        const month = parseInt(date.substring(4,6)) - 1;
        const dateObj = new Date(
            date.substring(0,4),
            month,
            date.substring(6,8),
            date.substring(8,10),
            date.substring(10,12),
            0
        );
        const hour = dateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        return `${date.substring(0,4)}/${date.substring(4,6)}/${date.substring(6,8)} ${hour}`;
    }, []);

    const editCallLog = useCallback(() => {
        toggleLoading(true);
        api.patch(`/ro.team.modifyLogGift/${currentGroup.id}`, {
            notes: editNotes,
            logId: currentLog.id,
            receiverId: currentLog.receiver.id
        })
            .then(() => {
                toast.success('Gift Log edited!');
                toggleModal();
                toggleModalEdit();
                if (toggleModalCallLogs) {
                    toggleModalCallLogs();
                }
                document.body.classList.remove('modal-open');
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [editNotes, currentGroup, currentLog, toggleLoading, toggleModal, toggleModalEdit, toggleModalCallLogs]);

    const showReceiverEmail = useCallback((email) => {
        if (email.includes('@noemail.com')) {
            return `No email`;
        } else {
            return email;
        }
    }, []);

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col lg="12">
                        <Card className="main-card mb-3">
                            <ListGroup className="todo-list-wrapper" flush>
                                {logs &&
                                    logs.map((log) => (
                                        <ListGroupItem key={log.id}>
                                            <div className="widget-content p-0">
                                                <div className="widget-content-wrapper">
                                                    <div className="widget-content-left">
                                                        <div className="widget-heading">
                                                            Senior: {log.receiver.name}
                                                        </div>
                                                        <div className="widget-subheading">
                                                            Volunteer: {log.giver.name}
                                                        </div>
                                                        <div className="widget-subheading">
                                                            <i>{convertDate(log.date)}</i>
                                                        </div>                                                        
                                                    </div>
                                                    <div className="widget-content-right">
                                                        <Button
                                                            className="mb-2 mr-2"
                                                            color="primary"
                                                            onClick={() => {
                                                                toggleModal();
                                                                setCurrentLog(log);
                                                            }}
                                                        >
                                                            Open
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </ListGroupItem>
                                    ))}
                            </ListGroup>
                        </Card>

                        {lastId !== null && (
                            <div className="text-center">
                                <Button
                                    className="btn-wide mb-2 mr-2"
                                    size="md"
                                    color="info"
                                    onClick={loadMore}
                                >
                                    Load more
                                </Button>
                            </div>
                        )}

                        {logs && logs.length === 0 && (
                            <Card className="main-card mb-3">
                                <CardBody>
                                    <p>This group does not have any logged calls yet.</p>
                                </CardBody>
                            </Card>
                        )}

                    </Col>
                </Row>

                <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>
                        Log
                    </ModalHeader>
                    <ModalBody>
                        {currentLog && (
                            <Fragment>
                                <p><b>Senior</b></p>
                                <p>
                                    {currentLog.receiver.name} [<i>{showReceiverEmail(currentLog.receiver.email)}</i>] <br/>
                                    Phone: {currentLog.receiver.phone}
                                </p>

                                <p><b>Volunteer</b></p>
                                <p>
                                    {currentLog.giver.name} [<i>{currentLog.giver.email}</i>] <br/>
                                    Phone: {currentLog.giver.phone}
                                </p>

                                {currentLog.notes && (
                                    <Fragment>
                                        <p><b>Notes</b></p>
                                        <p>
                                            {currentLog.notes}
                                        </p>
                                    </Fragment>
                                )}
                                
                                <p><i>{convertDate(currentLog.date)}</i></p>

                                <div className="text-center">
                                    <Button
                                        color="info"
                                        onClick={() => {
                                            toggleModalEdit();
                                            setEditNotes(currentLog.notes);
                                        }}
                                    >
                                        Edit Call Log
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </ModalBody>
                </Modal>

                <Modal isOpen={modalEdit} toggle={toggleModalEdit}>
                    <ModalHeader toggle={toggleModalEdit}>
                        Edit Call Log
                    </ModalHeader>
                    <ModalBody>
                        {currentLog && (
                            <Fragment>
                                <p><b>Senior</b></p>
                                <p>
                                    {currentLog.receiver.name} [<i>{showReceiverEmail(currentLog.receiver.email)}</i>] <br/>
                                    Phone: {currentLog.receiver.phone}
                                </p>

                                <p><b>Volunteer</b></p>
                                <p>
                                    {currentLog.giver.name} [<i>{currentLog.giver.email}</i>] <br/>
                                    Phone: {currentLog.giver.phone}
                                </p>

                                <FormGroup row>
                                    <Label sm="2">
                                        Notes
                                    </Label>
                                    <Col sm="10">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            value={editNotes}
                                            onChange={(e) => {
                                                setEditNotes(e.target.value);
                                            }}
                                        />
                                    </Col>
                                </FormGroup>

                                <div className="text-center">
                                    <Button
                                        color="info"
                                        className="mr-2"
                                        onClick={editCallLog}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        color="secondary"
                                        className="btn-small"
                                        onClick={toggleModalEdit}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                                
                            </Fragment>
                        )}
                    </ModalBody>
                </Modal>

            </Container>
        </Fragment>
    );
}
